import React from 'react';
import { LOGO_SRC } from './LenticLogo';
type LenticMarkProps = {
  /** Rendered square size in px. */
  size?: number;
  className?: string;
  /** Accessible label. Pass null for decorative use. */
  title?: string | null;
};

/**
 * The ripple mark on its own, cropped from the supplied lockup artwork so it is
 * always the original drawing. White is knocked out with multiply blending, so
 * it sits directly on the page background.
 */
export function LenticMark({
  size = 48,
  className,
  title = 'Lentic'
}: LenticMarkProps) {
  return <span className={['block overflow-hidden', className ?? ''].join(' ')} style={{
    width: size,
    height: size
  }} role={title ? 'img' : 'presentation'} aria-label={title ?? undefined} aria-hidden={title ? undefined : true} data-id="element-14" data-mp="1it3nt9wvv16w">
      <img src={LOGO_SRC} alt="" aria-hidden="true" className="h-full w-full select-none object-cover object-left mix-blend-multiply" data-id="element-15" data-mp="14ungbgr756np" />
    </span>;
}